import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Tooltip } from './Tooltip';
import { getTooltipPropsAsObject } from './utils';
import { primaryDarkColor } from '../../utils/styled-components/color-mixins/color-mixins';
export var TextWithTooltip = function (_a) {
    var children = _a.children, tooltipProps = _a.tooltip, _b = _a.component, component = _b === void 0 ? 'span' : _b;
    return (React.createElement(Tooltip, __assign({}, getTooltipPropsAsObject(tooltipProps)),
        React.createElement(TextElement, { as: component }, children)));
};
var TextElement = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  &:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 0px;\n    border-bottom: 2px dotted ", ";\n  }\n"], ["\n  position: relative;\n  &:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 0px;\n    border-bottom: 2px dotted ", ";\n  }\n"])), primaryDarkColor);
var templateObject_1;
//# sourceMappingURL=TextWithTooltip.js.map